
import * as ActionTypes from 'constants';

export const roleManagement = (state = {
	roles : [],
	selectedRole : '',
	showFeatures : false,
	show_delete_role_modal : false
}, action) => {
	let {type, payload} = action;
	var index;

	switch(type) {
		
		case ActionTypes.INITIALIZE_ROLES :
			return {...state, roles : payload.roles}
		case ActionTypes.INITIALIZE_ROLES_FAILED :
			return {...state, roles : []}
		case ActionTypes.CHANGE_SELECTED_ROLE :
			return {...state, ...payload}
		case ActionTypes.SHOW_FEATURES :
			return {...state, ...payload}
		case ActionTypes.ADD_FEATURE_TO_STATE :
			if(typeof payload.role_id === 'object')
				payload.role_id = payload.role_id._id

			index = state.roles.findIndex(r => r._id === payload.role_id);
			return {
				...state,
				roles : [
					...state.roles.slice(0, index),
					{...state.roles[index], features : [...state.roles[index].features, ...payload.features]},
					...state.roles.slice(index + 1)
				]
			}
		case ActionTypes.REMOVE_FEATURE_FROM_STATE : 
			index = state.roles.findIndex(r => r._id === payload.role_id);
			let temp_features = [...state.roles[index].features];
			payload.features_list.forEach(_pf => {
				temp_features = temp_features.filter(_tf => (
					(typeof _tf === 'object') ? _tf._id !== _pf : _tf !== _pf)
				)
			})
			return {
				...state,
				roles : [
					...state.roles.filter((e, i) => i < index),
					{...state.roles[index], features : temp_features},
					...state.roles.filter((e, i) => i > index)
				]
			}
		case ActionTypes.ADD_ROLE_TO_STATE :
			return {...state, roles : [...state.roles, payload.role]}
		case ActionTypes.DELETE_ROLE_FROM_STATE :
			return {
				...state,
				roles : state.roles.filter(r => r._id !== payload.role_id),
				selectedRole : ''
			}
		case ActionTypes.SHOW_DELETE_ROLE_MODAL :
			return {...state, show_delete_role_modal : true}
		case ActionTypes.HIDE_DELETE_ROLE_MODAL :
			return {...state, show_delete_role_modal : false}
		case ActionTypes.UPDATE_ROLE :
			index = state.roles.findIndex(r => r._id === payload._id)
			if(index >= 0) {
				return {...state, roles : [
						...state.roles.slice(0, index),
						payload,
						...state.roles.slice(index + 1)
					]}	
			}
			else
				break
		case ActionTypes.SET_ROLES_STATE : 
			return payload
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/common/reducers/roleManagement.js